export default __webpack_public_path__ + "static/media/logo-olympiakos.6ceb9458.png";